import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { getSecureItem } from './utilsFunctions';

const ProtectedRoute = ({ component: Component, permissions, requiredPermission, ...rest }) => {
  const userPermissions = getSecureItem("UsersAccess");

  return (
    <Route
      {...rest}
      render={(props) =>
        userPermissions && userPermissions[requiredPermission] ? (
          <Component {...props} />
        ) : (
          <Redirect to="/notfound" />
        )
      }
    />
  );
};

export default ProtectedRoute;
